import { render, staticRenderFns } from "./TableEditorRow.vue?vue&type=template&id=3628ba45&"
import script from "./TableEditorRow.vue?vue&type=script&lang=js&"
export * from "./TableEditorRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports